import {Directive, ElementRef, Input, OnInit} from '@angular/core';

export interface DiFormConfig {
    name: string;
}

@Directive({
    selector: '[diFormConfig]',
    standalone: false
})
export class DiFormConfigDirective implements OnInit {
    /**
     * Every call site writes this as a bare attribute (`<form diFormConfig ...>`), which binds
     * the empty string, so `''` is part of the input's real contract. Declaring it keeps
     * strictTemplates happy without touching 80 templates; ngOnInit already falls back to the
     * host <form>'s name attribute whenever no config object is supplied.
     */
    @Input('diFormConfig') formConfig: DiFormConfig | '';

    private _name: string;

    constructor(private elRef: ElementRef) {}

    ngOnInit(): void {
        if (this.formConfig && this.formConfig.name) {
            this._name = this.formConfig.name;
        } else if (this.elRef.nativeElement instanceof HTMLFormElement) {
            const form: HTMLFormElement = this.elRef.nativeElement as HTMLFormElement;
            this._name = form.name;
        }
    }

    get name(): string {
        return this._name;
    }
}
